module.exports = __webpack_public_path__ + "static/media/ags.de506e79.png";